<template>
	<div v-if="sportHasItems()" class="match_item">
		<div class="match_item-content" v-for="(item, key) in matches" :key="key + '-' + item.id" v-show="tourHasItems(item)">
			<div>
				<div class="match_item-header active">
					<span>{{ item.name }}</span>
					<i class="ico icon-side-arrow"></i>
				</div>
				<div class="match_item-data active">
					<div class="match-data">
						<router-link v-for="event in item.events" 
								:key="event.id" 
								:to="{ name: 'event', params: {id: event.id} }" 
								class="match-data_item"  
								v-show="showMatch(event)" 
								:class="{__base: isBiathlon}">
							<biathlon-link :type="type" :event="event" v-if="type === 'biathlon'"></biathlon-link>
							
							<tennis-link :type="type" :event="event" v-else-if="type === 'tennis'"></tennis-link>
							
							<default-link :type="type" :event="event" v-else></default-link>
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import _ from 'underscore';
	
	import BiathlonLink from "./MatchLinks/Biathlon";
	import TennisLink from "./MatchLinks/Tennis";
	import DefaultLink from "./MatchLinks/Default";
	
	export default {
		components: {
			BiathlonLink, TennisLink, DefaultLink
		},
		
		props: ['matches', 'title', 'filter', 'type'],
		
		computed: {
			isBiathlon() {
				return this.type === 'biathlon';
			}
		},
		
		methods: {
			showMatch(event) {
				if (this.filter) {
					return this.filter === event.status;
				}
				return  true;
			},
			tourHasItems(tour) {
				if (this.filter) {
					return !! _.find(tour.events, (event) => {
						return event.status === this.filter;
					});
				}
				return true;
			},
			sportHasItems() {
				if (this.filter) {
					for (let match in this.matches) {
						for (let event in this.matches[match]['events']) {
							if (this.matches[match]['events'][event].status === this.filter) {
								return true;
							}
						}
					}
					
					return false;
				}
				
				return true;
			},
		},
	}
</script>

<style scoped>

</style>